












































































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import Form, { Send } from '@/components/form-base';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import BasicHelperMixin from '@/components/helpers/basic-helper-mixin';
import { ErrorParseMethodEnum } from '@/services/models/Enums';
import MenuReportDialogsMixin from '@/views/layout/navigation/mixins/menu-report-dialogs-mixin';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import Template from '@/views/reports/forms/traffic_sources/template.vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import LandingApi from '@/services/rest/bemob/landing';
import availableTokens from '@/views/reports/forms/landing/config/availableTokens';
import TagApi from '@/services/rest/bemob/tag';


const md5 = require('md5');

interface CheckboxState {
  path: boolean,
  query: boolean,
  tags: boolean,
  domain: boolean,
  protocol: boolean
}

@Component({
  components: {
    Template,
    FormOverlay,
    DialogForm,
    ErrorAggregator,
    NoTagFound,
  }
})
export default class BulkEditDialog extends mixins<Form, ReportMixin, MenuReportDialogsMixin, BasicHelperMixin>(
    Form,
    ReportMixin,
    MenuReportDialogsMixin,
    BasicHelperMixin,
) {
  landingApi: LandingApi = new LandingApi();
  tagApi: TagApi = new TagApi();

  show: boolean = false;
  loading: boolean = false;

  form: any = { ...this.defaultBulkForm };
  checkboxState: CheckboxState = { ...this.defaultCheckboxState }
  //errors: any[] = [];
  errorsControlActive: boolean = false;
  errorMessage: string = '';
  errorsRaw: any = null;
  activeWorkspaceId: string = null;

  get chips() {
    return availableTokens.map(tag => ({
      tag,
      disabled: false
    }));
  }

  get selectedItems() {
    return this.$store.state.table.selectedItems.filter(({ isDirect }) => !isDirect)
  }

  get defaultBulkForm() {
    return {
      domain: '',
      path: '',
      query: '',
      tags: [],
      protocol: ''
    }
  }

  get defaultCheckboxState() {
    return {
      path: false,
      query: false,
      tags: false,
      domain: false,
      protocol: false,
    }
  }

  get errors() {
    return this.errorsRaw
        ? this.translateErrors(this.errorsRaw, this.errorMessage)
        : [];
  }

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify({ ...this.form, ...this.checkboxState }));
  }

  async mounted() {
    this.$on('error', (e: any) => {
      this.$store.commit('loading', false);

      this.errorsRaw = this.parseErrors(e.data.errors, ErrorParseMethodEnum.numerate);
      this.errorMessage = e.data.message;
      this.errorsControlActive = true;
    });

    this.$store.commit('loading', true);

    this.activeWorkspaceId = this.selectedItems[0].DT_RowWorkspaceId

    this.$store.commit('loading', false);
    this.show = true;
    this.oldHash = this.getCurrentHash();
    if(!this.$store.state.cache.tags.landings.isUploaded){
      await this.tagApi.populateStoreCache({type:'landings'})
    }
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');
    this.bus.emit('clear-report-selection');
  }

  get activeElements() {
    return Object.entries(this.checkboxState).reduce((acc, [key, value]) => {
      if (value) {
        return {
          ...acc,
          [key]: this.form[key],
        }
      }
      return acc
    }, {})
  }

  trackAnalytics(event, element_count:number){
    const {
      domain: domain_enabled,
      path: path_enabled,
      query: query_params_token_enabled,
      tags: tags_enabled,
    } = this.checkboxState;

    this.$mixpanel?.track(event, {
      element_count,
      domain_enabled,
      path_enabled,
      query_params_token_enabled,
      tags_enabled,
    });
  }


  @Send(true)
  submit() {
    const ids = this.selectedItems.map(({ DT_RowId }) => DT_RowId)

    const params:{ids:string[], tags?: Array<string | { id:string, name:string }>} = {
      ids,
      ...this.activeElements,
    }

    if(params?.tags){
      params.tags=params.tags?.map((item)=>(typeof item === 'string'  ? item : item.name));
    }

    return this.landingApi.bulkUpdate(this.activeWorkspaceId, params)
      .then(() => {
        this.trackAnalytics('landing_bulk_edit', ids.length)
        this.close()

        this.bus.emit('refresh-report');
        this.bus.emit('toast-success', this.t('Changes have been successfully saved'));
      })
  }

}
